export function getCurrentLanguageNodes(items, language) {
    return items.nodes.filter((item) => {
        return item.node_locale === language;
    });
};

export default {
    getCurrentLanguageNodes: getCurrentLanguageNodes
}
